import styled from 'styled-components';

export const Container = styled.div`
    position: fixed;
    padding: 10px;
    width: 100%;
    background-color: white;
    height: 60px;
    border-bottom: 1px solid #f0f0f0;
    position: relative;
}
`;
